import type { ExternalNote } from '@app/application/client_meetings/types'
import SFetch from '@app/utils/sfetch'

export async function attach(
  signedBlobId: string | null = null
): Promise<{ document: ExternalNote } | null> {
  const url = window.Silverfin.Routes.client_meetings_external_notes_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return await SFetch.json(url, {
    method: 'POST',
    body: { signed_blob_id: signedBlobId },
  })
}

async function deleteNote(documentId: number): Promise<void> {
  const url = window.Silverfin.Routes.client_meetings_external_note_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    documentId
  )

  await SFetch.raw(url, {
    method: 'DELETE',
  })
}

export { deleteNote as delete }
